import {Selectors} from '../Settings';

/**
 * PartnersList
 */
class PartnersList {
	constructor($partnersList) {
		this.$partnersList = $partnersList;

		this.equalize();
	}

	bindHandlers() {
		$(window).on('resize', () => {
			if($(this).width() >= 800) {
				this.equalize();
			}
		});
	}

	filterByLetter(letter) {
		let $partnersWithoutLetter = this.$partnersList.find(Selectors.partner + '[data-letter!="' + letter + '"]');
		let $partnersWithLetter = this.$partnersList.find(Selectors.partner + '[data-letter="' + letter + '"]');

		$partnersWithoutLetter.parent('.partner-column').addClass('filtered');
		$partnersWithLetter.parent('.partner-column').removeClass('filtered');

		this.$partnersList.find('.partner-column:visible:odd').css('clear', 'none');
		this.$partnersList.find('.partner-column:visible:even').css('clear', 'both');

		this.equalize();
	}

	removeFilter() {
		this.$partnersList.find('.partner-column').removeClass('filtered');
		this.$partnersList.find('.partner-column:visible:odd').css('clear', '');
		this.$partnersList.find('.partner-column:visible:even').css('clear', '');
	}

	equalize() {
		let heights = [],
			benefitHeights = [],
			$logos = this.$partnersList.find('.partners-list-partner .partner-logo'),
			counter = $logos.length,
			_self = this;

		function imageLoaded() {
			counter--;

			if(counter === 0) {
				_self.$partnersList.find('.partner-column').each(function() {
					let $partner = $(this).find('.partners-list-partner');

					heights.push($partner.height());
					benefitHeights.push($partner.find('.partner-benefit-remark').outerHeight());
				});

				_self.$partnersList.find('.partners-list-partner').css('height', Math.max(...heights));
				_self.$partnersList.find('.partners-list-partner .partner-benefit-remark').css('height', Math.max(...benefitHeights));
			}
		}

		$logos.each(function() {
			if(this.complete) {
				imageLoaded.call(this);
			} else {
				$(this).one('load', imageLoaded);
			}
		});
	}
}

export default (new PartnersList($(Selectors.partnersList)));